
    import { Input } from "element-ui";
    import Component from "vue-class-component";
    import { Prop, Vue } from "vue-property-decorator";
    import { isNumberValid } from "@/common/formValidator";

    @Component({
        components: {},
        extends: Input /* @see https://element.eleme.io/#/en-US/component/input */,
    })
    export default class AppInput extends Vue {
        @Prop({ required: false, default: false })
        forceNumber: boolean;

        @Prop({ required: false, default: false })
        forceWholeNumber: boolean;

        $refs: {
            input: HTMLInputElement;
        };

        regexp = /[^\d.]/g;

        mounted(): void {
            if (this.forceNumber && this.forceWholeNumber) {
                throw new Error("Not allowed to use forceNumber and forceWholeNumber at the same time!");
            }

            if (this.forceNumber || this.forceWholeNumber) {
                this.$refs.input.addEventListener("input", this.customInputHandler);
            }
        }

        // Monkey patching on input event to modify value
        customInputHandler(event: Event): void {
            let value = (event.target as HTMLInputElement).value;
            let isModified = false;

            if (!isNumberValid(value)) {
                value = (event.target as HTMLInputElement).value.replace(this.regexp, "");
                isModified = true;
            }

            if (this.forceWholeNumber) {
                const normalized = value.replace(/[^0-9]|^0+/g, "");
                if (value !== normalized) {
                    value = normalized;
                    isModified = true;
                }
            }

            if (isModified) {
                (event.target as HTMLInputElement).value = value;
                // call extended library component method to simulate user input interaction
                // checkout the actual lib component file: node_modules/element-ui/packages/input/src/input.vue
                (this as any).handleInput(event);
            }
        }

        beforeDestroy(): void {
            if (this.forceNumber || this.forceWholeNumber) {
                this.$refs.input.removeEventListener("input", this.customInputHandler);
            }
        }
    }
